var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_7_6",
    "data-name": "Component 7 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    transform: "translate(15 15) rotate(180)",
    fill: "none",
    stroke: "#006ad9",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 13.75,
    height: 13.75,
    rx: 3.375,
    fill: "none"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.e625334aea148aed0ed5f59e716ad79f.svg";
export { ForwardRef as ReactComponent };